import React, { FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { InfoBox } from '@components/cards/messageBox';
import { PanelItem } from '@components/panels/PanelItems';
import { Panel } from '@components/panels/Panel';
import { NavBar } from "@components/navigation/NavBar/NavBar";
import SubmitBtn from "@components/buttons/FormButtons/SubmitBtn";
import { OnboardingAgreementState } from './onboardingAgreementReducer';

interface FlexiOwnUsedVehicleAddendumV2Props {
  navigateTarget: string;
  onboardingAgreementState: OnboardingAgreementState;
}

export default function FlexiOwnUsedVehicleAddendumV2({
  navigateTarget,
  onboardingAgreementState,
}: FlexiOwnUsedVehicleAddendumV2Props) {
  const navigate = useNavigate();

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    navigate(navigateTarget);
  };

  return (
    <>
      <NavBar pageTitle={"Used Vehicle Addendum"} backAction={undefined} />
      <form style={{ margin: '2.5vh 2.5vw' }} onSubmit={onSubmit}>
        <div style={{ marginTop: '2.5vh' }}>
          <InfoBox message={'Data based on sales quote'} />
        </div>
        <div style={{ marginTop: '2.5vh', marginBottom: '2.5vh' }}>
          <PanelItem header='Term reduction (weeks)' value={onboardingAgreementState.termReduction} />
          <PanelItem header='Term length (weeks)' value={onboardingAgreementState.reducedTermLengthWeeks} />
        </div>
        <div style={{ marginTop: '2.5vh', marginBottom: '2.5vh' }}>
          <Panel title='Maintenance limits'>
            <PanelItem header='Replacement tyres' value={onboardingAgreementState.replacementTyres} />
            <PanelItem header='Replacement brake pads' value={onboardingAgreementState.replacementBrakePadSet} />
            <PanelItem header='Replacement of machining of brake discs' value={onboardingAgreementState.replacementOrMachiningOfBrakeDiscs} />
          </Panel>
        </div>
        <SubmitBtn text={"Continue"} />
      </form>
    </>
  );
}